import { InlineCalendarPicker } from './InlineCalendarPicker';
import { useCallback, useState, type ComponentProps } from 'react';
import { toKstDateString } from '@aegislab/shared';
import { getLocalToday } from '@/shared/lib/format';
import { usePendingCorrectionDates } from '../model/usePendingCorrectionDates';

export function CorrectionCalendarPicker(props: ComponentProps<typeof InlineCalendarPicker>) {
  const [month, setMonth] = useState(() => getLocalToday().slice(0, 7));
  // 현지 날짜로 배치된 달력 칸을 빠뜨리지 않도록 월 양끝을 KST 근태일로 덮는다.
  const start = new Date(`${month}-01T00:00:00`);
  const end = new Date(start.getFullYear(), start.getMonth() + 1, 0, 23, 59, 59, 999);
  const pendingAttendanceIds = usePendingCorrectionDates(
    toKstDateString(start),
    toKstDateString(end)
  );
  const { onMonthChange } = props;
  const handleMonthChange = useCallback(
    (nextMonth: string) => {
      setMonth(nextMonth);
      onMonthChange?.(nextMonth);
    },
    [onMonthChange]
  );
  return (
    <InlineCalendarPicker
      {...props}
      onMonthChange={handleMonthChange}
      pendingAttendanceIds={pendingAttendanceIds}
      hideAbsentSessionLabel
    />
  );
}
